<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
};
</script>

<style>
@import url("../static/css/reset.css");
@import url("../static/css/Public.css");
.bill .el-table td {
  border-top: 2px solid #999999!important;
  border-bottom: none!important;
  box-sizing: border-box
}
.bill .el-table th {
  border-top: 1px solid #999999!important;
  border-bottom: none!important;
  box-sizing: border-box
}

.el-table th.gutter {
  display: table-cell !important
}
</style>



// WEBPACK FOOTER //
// src/App.vue